import { buildCsvFromRows } from '../../shared/csv-core/infra/buildCsv';
import type { ExpenseRow } from '../domain/expenseTypes';
import { expenseAmountResidual, expensePaymentStatusLabel } from '../domain/expenseLabels';
import { expenseErpCopy } from '../domain/expenseErpCopy';

export function buildExpensesListCsv(rows: ExpenseRow[]): string {
  const headers = [
    'Fecha',
    'Vencimiento',
    'Proveedor',
    'Categoría',
    expenseErpCopy.columnTotal,
    expenseErpCopy.columnPaid,
    expenseErpCopy.columnBalance,
    expenseErpCopy.columnStatus,
    'Descripción',
    'Comprobante',
    'ID factura',
  ];
  const data = rows.map((row) => {
    const residual = expenseAmountResidual(row.amount, row.amountPaid);
    return [
      row.expenseDate,
      row.dueDate ?? '',
      row.supplierName ?? '',
      row.categoryName ?? row.categorySlug ?? '',
      String(row.amount),
      String(row.amountPaid),
      String(residual),
      expensePaymentStatusLabel(row.paymentStatus),
      row.description ?? '',
      row.receiptRef ?? '',
      row.id,
    ];
  });
  return buildCsvFromRows(headers, data);
}
